var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C759A760-D284-4112-8779-18BC0F24FA30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.09756098%",
    y1: "76.8292683%",
    x2: "89.0243902%",
    y2: "20.7317073%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4AF37",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A28014",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leads-Tracker",
    transform: "translate(-215.000000, -88.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(214.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Lead-Icon",
    transform: "translate(1.025822, 4.533173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8409471,2.00329498 L13.8409471,13.8409471 L2.00329498,13.8409471 C1.70170802,13.8409471 1.4569418,14.0857133 1.4569418,14.3873003 C1.4569418,14.6888872 1.70170802,14.9336535 2.00329498,14.9336535 L14.3873003,14.9336535 C14.6888872,14.9336535 14.9336535,14.6888872 14.9336535,14.3873003 L14.9336535,2.00329498 C14.9336535,1.70170802 14.6888872,1.4569418 14.3873003,1.4569418 C14.0857133,1.4569418 13.8409471,1.70170802 13.8409471,2.00329498 Z M12.7482408,1.27482408 C12.7482408,0.936813578 12.6138379,0.612644027 12.3748994,0.373341336 C12.1355967,0.134402881 11.8114272,0 11.4734167,0 L1.27482408,0 C0.936813578,0 0.612644027,0.134402881 0.373341336,0.373341336 C0.134402881,0.612644027 0,0.936813578 0,1.27482408 L0,11.4734167 C0,11.8114272 0.134402881,12.1355967 0.373341336,12.3748994 C0.612644027,12.6138379 0.936813578,12.7482408 1.27482408,12.7482408 L11.4734167,12.7482408 C11.8114272,12.7482408 12.1355967,12.6138379 12.3748994,12.3748994 C12.6138379,12.1355967 12.7482408,11.8114272 12.7482408,11.4734167 L12.7482408,1.27482408 Z M5.8277672,5.8277672 L4.18870768,5.8277672 C3.88712072,5.8277672 3.6423545,6.07253342 3.6423545,6.37412038 C3.6423545,6.67570733 3.88712072,6.92047355 4.18870768,6.92047355 L5.8277672,6.92047355 L5.8277672,8.55953308 C5.8277672,8.86112003 6.07253342,9.10588625 6.37412038,9.10588625 C6.67570733,9.10588625 6.92047355,8.86112003 6.92047355,8.55953308 L6.92047355,6.92047355 L8.55953308,6.92047355 C8.86112003,6.92047355 9.10588625,6.67570733 9.10588625,6.37412038 C9.10588625,6.07253342 8.86112003,5.8277672 8.55953308,5.8277672 L6.92047355,5.8277672 L6.92047355,4.18870768 C6.92047355,3.88712072 6.67570733,3.6423545 6.37412038,3.6423545 C6.07253342,3.6423545 5.8277672,3.88712072 5.8277672,4.18870768 L5.8277672,5.8277672 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/AddNew.9b728f64874d992bb42bf16aa459e430.svg";
export { ForwardRef as ReactComponent };